import { readUserProfile } from '@usehatchapp/javascript-sdk';
import camelcaseKeys from 'camelcase-keys';
import validateSchema from 'utils/validateSchema';

import { SET_FRESH_USER_KEY } from '../../fresh';
import { USER_ORGANIZATIONS } from '../../fresh/schema';
import { constants as organizationConstants } from '../../organizations';
import { userConstants } from '../constants';
import { userSchema } from '../schema';

// gets user profile for logged in user
export const doReadUserProfile =
  () =>
  async ({ dispatch, getState, store, request }) => {
    const {
      READ_USER_PROFILE_FAILURE,
      READ_USER_PROFILE_REQUEST,
      READ_USER_PROFILE_SUCCESS,
    } = userConstants;
    const { READ_ORGANIZATIONS_BY_USER_SUCCESS } = organizationConstants;

    try {
      // get logged in user
      const state = getState();
      const user = store.selectUser(state);

      // if no user object present, then fail
      if (!user)
        dispatch({
          error: 'Required parameter of user was not supplied',
          type: READ_USER_PROFILE_FAILURE,
        });

      // tell state we're fetching user profile
      dispatch({ type: READ_USER_PROFILE_REQUEST });

      // get user profile
      // omit `id` from the userProfile object because it is the wrong id value (it isn't the userId)
      const { id, ...userProfile } = await request(readUserProfile, {
        userId: user.id,
      });

      // validate user profile
      const validUser = validateSchema({
        payload: camelcaseKeys({ ...user, ...userProfile }, { deep: true }),
        schema: userSchema,
      });
      const {
        permissions: { organizationManagers: organizationsByUser = [] } = {},
      } = validUser;

      // otherwise dispatch validated user profile to reducer
      dispatch({
        actions: [
          { payload: validUser, type: READ_USER_PROFILE_SUCCESS },
          {
            payload: { organizationsByUser },
            type: READ_ORGANIZATIONS_BY_USER_SUCCESS,
          },
          {
            payload: { fresh: true, key: USER_ORGANIZATIONS },
            type: SET_FRESH_USER_KEY,
          },
        ],
        type: 'BATCH_ACTIONS',
      });
    } catch (error) {
      dispatch({ error, type: READ_USER_PROFILE_FAILURE });
    }
  };
